import { useState } from "react";
import React from "react";
import { useSelector } from "react-redux";
import { Formik, Field, Form } from "formik";
import { useEffect } from "react";

export const SlotPickerPopup = ({
  data,
  weekSlotData,
  setData,
  weekSlotName,
  setIsOpenSelectTime,
  setWeekSlotData,
  setWeekSlotName,
}) => {
  const [slotData, setSlotData] = useState(null);
  const getWorkingHoursSlot = useSelector(
    (state) => state?.InfrastructureDetailsReducer?.getWorkingHoursSlot
  );
  useEffect(() => {
    if (slotData) {
      const temp = slotData?.numbers?.toString();
      const string = temp?.charAt(0) === "," ? temp?.substring(1) : temp;
      setData({
        ...data,
        [weekSlotName?.slots]: string,
        [weekSlotName?.value]: string?.length ? true : false,
      });
    }
  }, [slotData]);

  return (
    <div className="modal-content">
      <div className="modal-body">
        <div className="modal-top">
          <h2>
            Pick a
            {weekSlotName?.slots
              ?.replace(/([A-Z])/g, " $1")
              ?.trim()
              ?.toLowerCase()}
          </h2>
        </div>
        <Formik initialValues={{ numbers: weekSlotData?.split(",") }}>
          {({ values, setFieldValue }) => {
            setSlotData(values);
            return (
              <Form>
                <div>
                  <input
                    type="checkbox"
                    onClick={(e) =>
                      e.target.checked
                        ? setFieldValue(
                            "numbers",
                            getWorkingHoursSlot.map((ele) =>
                              ele?.timeSlotId.toString()
                            )
                          )
                        : setFieldValue("numbers", "")
                    }
                    checked={
                      getWorkingHoursSlot?.length === values?.numbers?.length
                    }
                    style={{
                      marginRight: "5px",
                      marginTop: "10px",
                      width: "20px",
                      height: "15px",
                    }}
                  />
                  Select All
                </div>
                <div className="select-time-interval">
                  {getWorkingHoursSlot.map((ele) => (
                    <label className="labelselecttime">
                      <Field
                        type="checkbox"
                        name="numbers"
                        key={ele?.timeSlotId.toString()}
                        value={ele?.timeSlotId.toString()}
                      />
                      <span className="selecttimespan">
                        {ele?.startTime} - {ele?.endTime}
                      </span>
                    </label>
                  ))}
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className="modal-footer">
        <button
          className="btn btn-primary"
          data-bs-dismiss="modal"
          type="button"
          onClick={() => {
            setIsOpenSelectTime(false);
            setWeekSlotData(null);
            setWeekSlotName(null);
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};
